import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

export const PENDING_FREE_PLAN_WHEEL_STORAGE_KEY = 'pendingFreePlanWheel';

@Injectable({ providedIn: 'root' })
export class PendingFreePlanWheelStorageService {
  private readonly platformId = inject(PLATFORM_ID);

  public save(payload: PendingFreePlanWheelPayload): void {
    if (!isPlatformBrowser(this.platformId)) return;

    sessionStorage.setItem(PENDING_FREE_PLAN_WHEEL_STORAGE_KEY, JSON.stringify(payload));
  }

  public read(): PendingFreePlanWheelPayload | null {
    if (!isPlatformBrowser(this.platformId)) return null;

    const storedPayload = sessionStorage.getItem(PENDING_FREE_PLAN_WHEEL_STORAGE_KEY);
    if (!storedPayload) return null;

    try {
      return JSON.parse(storedPayload) as PendingFreePlanWheelPayload;
    } catch {
      return null;
    }
  }

  public saveSession(session: CreateSessionDto): void {
    const payload = this.read();
    if (!payload) return;

    this.save({ ...payload, session });
  }

  public remove(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    sessionStorage.removeItem(PENDING_FREE_PLAN_WHEEL_STORAGE_KEY);
  }
}
